// extracted by mini-css-extract-plugin
module.exports = {"Faq":"Faq_Faq__rTB1h"};